/**
 * Testimonial video playback.
 *
 * The carousel itself is feature-carousel.js — the same centre-focus loop as
 * Explore by Features. This file only plays a filmed testimonial when its play
 * button is pressed, and resets the card when the clip ends.
 *
 * Delegated from the document rather than bound per card: the carousel clones
 * cards for its loop, and a clone must play exactly like the card it copies.
 * Media events do not bubble, so `ended` is caught in the capture phase.
 *
 * No autoplay: these carry a person's voice, so playback is always the
 * visitor's choice. A clip that leaves the centre is paused by the carousel
 * (`data-fc-pause-inactive` on the section's <feature-carousel>).
 *
 * Guarded, because every `<script src>` executes on each occurrence.
 */
(() => {
  if (window.foamicoTestimonialVideo) return;
  window.foamicoTestimonialVideo = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-testimonial-play]');
    if (!button) return;

    const media = button.closest('[data-testimonial-media]');
    const video = media?.querySelector('[data-testimonial-video]');
    if (!video) return;

    media.classList.add('is-playing');
    video.controls = true;
    video.play().catch(() => {});
  });

  document.addEventListener(
    'ended',
    (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement) || !video.matches('[data-testimonial-video]')) return;

      video.controls = false;
      video.currentTime = 0;
      video.closest('[data-testimonial-media]')?.classList.remove('is-playing');
    },
    true
  );
})();
